@if (Site && CompanyId) {
  <div class="container-fluid">
    <!-- VPDW-3111: wrap the flat label/value list in a card so the
         site detail page reads as a contained data block rather than a
         loose page-level form. Two-column field grid matches the rest
         of the brand. -->
    <app-display-card>
      <div class="row g-4 site-detail-grid">
        <div class="col-md-6">
          <label class="form-label d-block">Legal name</label>
          <span class="site-detail-value">{{ Site.legalName }}</span>
        </div>
        <div class="col-md-6">
          <label class="form-label d-block">DBA</label>
          <span class="site-detail-value">{{ Site.dba || '—' }}</span>
        </div>
        <div class="col-md-6">
          <label class="form-label d-block">Phone</label>
          <span class="site-detail-value">{{ Site.phone || '—' }}</span>
        </div>
        <div class="col-md-6">
          <label class="form-label d-block">Status</label>
          <span class="site-detail-value" appStatusStyleChanges>
            {{ Site.status | uppercase }}
          </span>
        </div>
        <div class="col-md-6">
          <label class="form-label d-block">Account key</label>
          <span class="site-detail-value">{{ Site.siteKey || '—' }}</span>
        </div>
        <div class="col-md-6">
          <label class="form-label d-block">EIN (Tax ID #)</label>
          <span class="site-detail-value">{{ Site.ein || '—' }}</span>
        </div>
        @if (siteAddress) {
          <div class="col-12">
            <label class="form-label d-block">Address</label>
            <span class="site-detail-value">
              {{
                (siteAddress.address1 || '') +
                  ' ' +
                  (siteAddress.address2 || '') +
                  ' ' +
                  (siteAddress.city || '') +
                  ' ' +
                  (siteAddress.state || '') +
                  ' ' +
                  (siteAddress.zip || '')
              }}
            </span>
          </div>
        }
      </div>
    </app-display-card>

    <div class="action-row justify-end mt-3">
      <button class="btn btn-primary" (click)="createQSB()">
        Create QuickSource bid
      </button>
      @if (hasEditPermissions) {
        <button class="btn btn-outline" (click)="editDetails()">
          Edit details
        </button>
      }
    </div>
  </div>
}
